import { toast } from "sonner";

export const useClipboard = () => {
  const copy = async (value: string) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(value);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = value;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      toast.success("Copied to clipboard");
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Copy failed");
    }
  };

  return { copy };
};
